import { FaSort, FaDownload } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import PoliticaPrivacidadPopup from '../PoliticaPrivacidadPopup';
import { handleError } from '../utils/errorHandler';
import { colorsRangeHex, formatNumber } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from './SesionDetalles';
import { useUrlParams } from '../hooks/useUrlParams';
import { API_URL, HEIGHT_BODY, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE } from '../Config';
import { apiFetch } from '../apiClient';

let filterAnio = "";
let filterTipoClasificador = "";
let filterCodigoDivipolaPdetRegion = "";
let filterCodigoDivipolaPdetMunicipio = "";
let filterCodigoDivipolaDpto = "";
let filterCodigoDivipolaMpio = "";
let filterSector = "";
let filterEntidad = "";
let filterEsPDET = "";
let fechasActualizacion: FechasActualizacion[] = [];


class FechasActualizacion {
    public anio: string = "";
    public tipoClasificador: string = "";
    public idVariable: number = 0;
    public idTipoValor: number = 0;
    public sector: string = "";
    public entidad: string = "";
    public fechaReporte: string = "";
}

interface BarraProps {
    filtrar: string;
    codigoDivipola: string;
}

const Fechas: React.FC<BarraProps> = ({ filtrar, codigoDivipola }) => {
        const { tiposClasificadores } = useUrlParams();
    const [fechaPND, setFechaPND] = useState<string>("");
    const [fechaPaz, setFechaPaz] = useState<string>("");

    const fetchDatos = async () => {
        try {
            const startTime = performance.now();
            const queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=`)//${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetFechasActualizacion?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            const formattedData = data.map((item: FechasActualizacion) => ({
                ...item,
                fechaReporte: item.fechaReporte.split('T')[0]
            }));
            fechasActualizacion = formattedData;
            updateRenderer();
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Barras Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const getMaxFechaPorTipoClasificador = () => {
        var variable29 = fechasActualizacion.filter((element: FechasActualizacion) => element.tipoClasificador == "PND" && element.anio == "2024" && element.idVariable == 29); 
        const maxFechas: { [key: string]: Date } = {};
        fechasActualizacion.forEach((element: FechasActualizacion) => {
            const currentMaxFecha = maxFechas[element.tipoClasificador];
            if (element.anio == "2019" && element.idVariable == 212) { 
                //console.log("variable29", variable29);            
            }
            var fechaAux = new Date(
                parseInt(element.fechaReporte.split('-')[0]),
                parseInt(element.fechaReporte.split('-')[1]) - 1,
                parseInt(element.fechaReporte.split('-')[2])
            );
            if (!currentMaxFecha || fechaAux > currentMaxFecha) {
                maxFechas[element.tipoClasificador] = fechaAux;
            }
        });
        return maxFechas;
    };

    const updateRenderer = () => {
        try {
            const maxFechas = getMaxFechaPorTipoClasificador();
            const fechaPNDMaxima = maxFechas["PND"] ? maxFechas["PND"].toLocaleDateString() : "1900-01-01";
            const fechaPazPMIMaxima = maxFechas["PMI"] ? maxFechas["PMI"].toLocaleDateString() : "1900-01-01";
            const fechaPazPNSMaxima = maxFechas["PNS"] ? maxFechas["PNS"].toLocaleDateString() : "1900-01-01";
            const fechaPazPMIPNSMaxima = maxFechas["PMI, PNS"] ? maxFechas["PMI, PNS"].toLocaleDateString() : "1900-01-01";
            const fechaPazMaxima = [fechaPazPMIMaxima, fechaPazPNSMaxima, fechaPazPMIPNSMaxima].sort().reverse()[0];
            setFechaPND(fechaPNDMaxima);
            setFechaPaz(fechaPazMaxima);
        } catch (error) {
            handleError(error);
        }
    };

    const getDatos = async () => {
        console.log(DEFAULT_FILTER);
        if (DEFAULT_FILTER.anio != filterAnio
            || DEFAULT_FILTER.tipoClasificador != filterTipoClasificador
            || filterCodigoDivipolaPdetRegion != DEFAULT_FILTER.codigoDivipolaPdetRegion
            || filterCodigoDivipolaPdetMunicipio != DEFAULT_FILTER.codigoDivipolaPdetMunicipio
            || DEFAULT_FILTER.codigoDivipolaDpto != filterCodigoDivipolaDpto
            || DEFAULT_FILTER.codigoDivipolaMpio != filterCodigoDivipolaMpio
            || DEFAULT_FILTER.sector != filterSector
            || DEFAULT_FILTER.entidad != filterEntidad
            || DEFAULT_FILTER.esPDET != filterEsPDET
        ) {
            filterAnio = DEFAULT_FILTER.anio;
            filterTipoClasificador = DEFAULT_FILTER.tipoClasificador;
            filterCodigoDivipolaPdetRegion = DEFAULT_FILTER.codigoDivipolaPdetRegion;
            filterCodigoDivipolaPdetMunicipio = DEFAULT_FILTER.codigoDivipolaPdetMunicipio;
            filterCodigoDivipolaDpto = DEFAULT_FILTER.codigoDivipolaDpto;
            filterCodigoDivipolaMpio = DEFAULT_FILTER.codigoDivipolaMpio;
            filterSector = DEFAULT_FILTER.sector;
            filterEntidad = DEFAULT_FILTER.entidad;
            filterEsPDET = DEFAULT_FILTER.esPDET;
            fetchDatos();
        }
        else {
            if (fechasActualizacion.length > 0) {
                updateRenderer();
            }
        }
    }


    useEffect(() => {
        getDatos();
    }, [fechasActualizacion, filtrar, codigoDivipola]);

    const [showPrivacidad, setShowPrivacidad] = useState(false);
    return (
        <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', width: '100%' }}>
                <div id="fechasDiv" style={{ flex: 1, minWidth: 0, height: "auto", paddingLeft: '10px', paddingRight: '20px', fontSize: "10px" }}>
                    <b style={{ color: '#36c' }}>Última Actualización:</b>
                    {/* Mostrar fechas según tiposClasificadores */}
                    {(() => {
                        const tipos = (tiposClasificadores || DEFAULT_FILTER.tipoClasificador || '').split('|').map(t => t.trim());
                        let showPND = tipos.includes('PND');
                        let showPMI = tipos.includes('PMI');
                        let showPNS = tipos.includes('PNS');
                        let showPMIPNS = tipos.includes('PMI, PNS');
                        let fechas = [];
                        if (showPND) fechas.push(<span key="PND"><b>PND:</b> {fechaPND} </span>);
                        if (showPMI || showPNS || showPMIPNS) fechas.push(<span key="PAZ"><b>PAZ:</b> {fechaPaz} </span>);
                        return fechas.length > 0 ? fechas : <span><b>PND:</b> {fechaPND}</span>;
                    })()}
                    <div style={{ marginTop: '4px' }}>
                        La información territorial y poblacional disponible en esta página está en proceso de pruebas y validación final. <br />
                        {(() => {
                            const tipos = (tiposClasificadores || DEFAULT_FILTER.tipoClasificador || '').split('|').map(t => t.trim());
                            if (tipos.includes('PND') && (tipos.includes('PMI') || tipos.includes('PNS') || tipos.includes('PMI, PNS'))) {
                                return (
                                    <span>
                                        Si requiere alguna consulta puntual de información desagregada puede descargar los archivos disponibles en{' '}
                                        <a href="https://sinergia20app.dnp.gov.co/ciudadano" target="_blank" rel="noreferrer" style={{ color: '#2c66a4', textDecoration: 'underline' }}>
                                            SINERGIA v2.0 » Inicio ciudadano
                                        </a>{' '}
                                        y{' '}
                                        <a href="https://siipo.dnp.gov.co/inicio" target="_blank" rel="noreferrer" style={{ color: '#2c66a4', textDecoration: 'underline' }}>
                                            SIIPO » Inicio
                                        </a>.
                                    </span>
                                );
                            } else if (tipos.includes('PND')) {
                                return (
                                    <span>
                                        Si requiere alguna consulta puntual de información desagregada puede descargar los archivos disponibles en{' '}
                                        <a href="https://sinergia20app.dnp.gov.co/ciudadano" target="_blank" rel="noreferrer" style={{ color: '#2c66a4', textDecoration: 'underline' }}>
                                            SINERGIA v2.0 » Inicio ciudadano
                                        </a>.
                                    </span>
                                );
                            } else {
                                return (
                                    <span>
                                        Si requiere alguna consulta puntual de información desagregada puede descargar los archivos disponibles en{' '}
                                        <a href="https://siipo.dnp.gov.co/inicio" target="_blank" rel="noreferrer" style={{ color: '#2c66a4', textDecoration: 'underline' }}>
                                            SIIPO » Inicio
                                        </a>.
                                    </span>
                                );
                            }
                        })()}
                    </div>
                </div>
                <div style={{ minWidth: 180, textAlign: 'left', padding: '10px 10px 0 0' }}>
                    <a href="#" onClick={e => { e.preventDefault(); setShowPrivacidad(true); }} style={{ color: '#2c66a4', textDecoration: 'underline', fontSize: 12 }}>
                        Política de Privacidad
                    </a>
                </div>
            </div>
            {showPrivacidad && <PoliticaPrivacidadPopup onClose={() => setShowPrivacidad(false)} />}
        </div>
    );
};


export default Fechas;